import { t } from 'i18next';

import LabelBadge from '~components/Common/LabelBadge';

export default function EmailIntakeBadge() {
  return <LabelBadge label={t('common.email_intake_badge')} />;
}
